<script lang="ts">
  import cornerTopLeft from 'src/components/main/#assets/top-left-border.svg'
  import cornerTopRight from 'src/components/main/#assets/top-right-border.svg'
  import cornerBottomLeft from 'src/components/main/#assets/bottom-left-border.svg'
  import cornerBottomRight from 'src/components/main/#assets/bottom-right-border.svg'
  import telegramIcon from './telegram.svg'
  import xIcon from './x.svg'
  import emailIcon from './email.svg'
</script>

<section class="contact" id="contact">
    <div class="container">
        <div class="title">
            Contact
            <div class="corner top-left" style="--cornerTopLeft: url({cornerTopLeft});"></div>
            <div class="corner top-right" style="--cornerTopRight: url({cornerTopRight});"></div>
            <div class="corner bottom-left" style="--cornerBottomLeft: url({cornerBottomLeft});"></div>
            <div class="corner bottom-right" style="--cornerBottomRight: url({cornerBottomRight});"></div>
        </div>
        <div class="items">
            <a href="https://t.me/RealisANN" class="item" target="_blank">
                <img src="{telegramIcon}" alt="">
            </a>
            <a href="https://x.com/realisnetwork" class="item" target="_blank">
                <img src="{xIcon}" alt="">
            </a>
            <a href="mailto:support@realis.network" class="item">
                <img src="{emailIcon}" alt="">
            </a>
        </div>
    </div>
</section>

<style>
    .contact {
        position: relative;
        margin-bottom: 150px;
        z-index: 3;
    }

    .title {
        font-size: 100px;
        font-weight: 700;
        padding: 18px 18px 0;
        background: linear-gradient(84deg, #FFF0E2 47%, #FFB287 71%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: normal;
        text-transform: uppercase;
        display: table;
        margin: 0 auto 100px;
        position: relative;
    }

    .corner {
        width: 15px;
        height: 15px;
        position: absolute;
        transition: .3s;
    }

    .corner.top-left {
        top: 0;
        left: 0;
        background: var(--cornerTopLeft) no-repeat top left;
    }

    .corner.top-right {
        top: 0;
        right: 0;
        background: var(--cornerTopRight) no-repeat top right;
    }

    .corner.bottom-left {
        bottom: 0;
        left: 0;
        background: var(--cornerBottomLeft) no-repeat bottom left;
    }

    .corner.bottom-right {
        bottom: 0;
        right: 0;
        background: var(--cornerBottomRight) no-repeat bottom right;
    }

    .items {
        display: flex;
        justify-content: center;
        position: relative;
        z-index: 2;
    }

    .item {
        margin: 0 88px;
        display: block;
        transition: .2s;
    }

    .item:hover {
        transform: scale(1.1);
    }

    .item img {
        width: 260px;
        height: auto;
    }

    @media(max-width: 1750px) {
        .item img {
            width: 220px;
        }
    }

    @media(max-width: 1520px) {
        .item img {
            width: 200px;
        }
    }

    @media(max-width: 1400px) {
        .title {
            font-size: 70px;
            margin: 0 auto 80px;
        }

        .item img {
            width: 170px;
        }
    }

    @media(max-width: 1200px) {
        .item {
            margin: 0 50px;
        }

        .item img {
            width: 150px;
        }

        .title {
            font-size: 60px;
        }
    }

    @media(max-width: 991px) {
        .title {
            font-size: 40px;
            width: 100%;
            text-align: center;
            padding: 5px 10px 0;
            margin-bottom: 50px;
        }

        .item {
            margin: 0 30px;
        }

        .item img {
            width: 110px;
        }

        .contact {
            margin-bottom: 60px;
        }
    }

    @media(max-width: 767px) {
        .item {
            margin: 0 7px;
        }
    }
</style>
